<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoMultiploArticolo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Azienda</label>
                        <b-form-input v-model="filtroMultiploArticolo.codiceAzienda" type="search" placeholder="Inserire Codice Azienda"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Multiplo</label>
                        <b-form-input v-model="filtroMultiploArticolo.multiploMultiplo" type="search" id="nome" placeholder="Inserire Multiplo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Descrizione Multiplo</label>
                        <b-form-input v-model="filtroMultiploArticolo.descrizioneMultiplo" type="search" placeholder="Inserire Descrizione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazioni-magazzino-articoli-multiplo-list-component ref="cmpConfigurazioniMagazzinoMultiploArticoliList" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioniMagazzinoArticoliMultiploListComponent from "../components/ConfigurazioniMagazzinoArticoliMultiploListComponent.vue";
export default {
    components: { SaPageLayout, ConfigurazioniMagazzinoArticoliMultiploListComponent },

    data() {
        return {
            dadefinire: null,
            filtroMultiploArticolo: {
                codiceAzienda: null,
                multiploMultiplo: null,
                descrizioneMultiplo: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "",
            linkConfigurazioni: "/configurazionemagazzino",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoMultiploArticoliList.loadDataMultiploArticoli();
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroMultiploArticoli"] = JSON.stringify(me.filtroMultiploArticolo);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroMultiploArticolo = { codiceAzienda: null, multiploMultiplo: null, descrizioneMultiplo: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroMultiploArticoli"] = JSON.stringify(me.filtroMultiploArticolo);
            me.loadData();
        },
        onClickNuovoMultiploArticolo() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoMultiploArticoliList.onNuovoMultiploArticolo();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroMultiploArticolo = filterData;
        },
    },
};
</script>
